import React from 'react';
import { Modal, ModalBody, ModalHeader } from '../../../components/Bootstrap';
import { UserListQuery_roles as Role } from './__generated__/UserListQuery';

interface InfoModalProps {
  roles: Role[];
  open: boolean;
  toggle(): void;
}

export class InfoModal extends React.PureComponent<InfoModalProps> {
  render() {
    return (
      <Modal size='sm' isOpen={this.props.open} className='user-info-modal' toggle={this.props.toggle}>
        <ModalHeader className='justify-content-center'>Role Permissions</ModalHeader>
        <ModalBody>
          <div className='user-info-modal-columns'>
            {this.props.roles.map((role) => (
              <div className='user-info-modal-role mb-3' key={role.id}>
                <h5>{role.name}</h5>
                <p className='user-info-modal-permissions'>
                  {role.permissions.map((permission) => (
                    <div key={permission}>{permission}</div>
                  ))}
                </p>
              </div>
            ))}
          </div>
        </ModalBody>
      </Modal>
    );
  }
}
